import { render } from "./PaymentSuccess.vue?vue&type=template&id=2420ff3e&scoped=true"
const script = {}

import "./PaymentSuccess.vue?vue&type=style&index=0&id=2420ff3e&scoped=true&lang=css"

import exportComponent from "/var/www/pd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2420ff3e"]])

export default __exports__